import { render, staticRenderFns } from "./Interativa.vue?vue&type=template&id=7071bcc3&"
import script from "./Interativa.vue?vue&type=script&lang=js&"
export * from "./Interativa.vue?vue&type=script&lang=js&"
import style0 from "./Interativa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports